import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { Button, Header } from '../../../components';
import { loggerSendingData } from '@/redux/actions/logger.action';
import { cartSelector } from '@/redux/cart/selectors';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '@/redux/store';
import { openFeedbackModal } from '@/redux/feedback/slice';
import { ModalFeedback } from '@/pages/Contacts/components/ModalFeedback/ModalFeedback';

import styles from './PaymentSuccess.module.scss';
import paymentErrorImg from '@/assets/img/paymentErrorImg.svg';
import techRequest from '@/assets/icons/techRequest.svg';
import arrowIcon from "@/assets/icons/arrowCalendarRightGreen.svg";

interface PaymentErrorState {
  errorReason?: string;
  errorType?: string;
  orderId?: string | null;
}

export const PaymentError: React.FC = () => {
  const location = useLocation();
  const dispatch = useAppDispatch();
  const { pathname } = useLocation();
  const { totalCartItems } = useSelector(cartSelector);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    loggerSendingData({
      type: 'ErrorPaymentScreenLocalData',
      data: {
        courtRent: totalCartItems.seats || {},
        racketRent: totalCartItems.rackets || {},
        errorState: location.state,
      },
    }).catch((error) => {
      console.warn('Ошибка логирования ErrorPaymentScreen:', error);
    });
  }, []);

  const errorState = location.state as PaymentErrorState | string | null;
  const errorReason =
    typeof errorState === 'object' && errorState?.errorReason
      ? errorState.errorReason
      : typeof errorState === 'string'
      ? errorState
      : 'Произошла ошибка при оплате';

  const handleFeedbackClick = () => {
    dispatch(openFeedbackModal());
  };

  return (
    <>
      <Header title={''} />
      <main>
        <section className={styles.wrapper}>
          <div className={styles.errorPayment}>
            <div className={styles.image}>
              <img src={paymentErrorImg} alt="payment error" />
            </div>

            <div className={styles.textWrapper}>
              <p className={styles.errorPaymentTitle}>
                Упс! Кажется что-то пошло не так
              </p>
              {errorReason &&
                <p className={styles.subTitile}>{errorReason}</p>
              }
            </div>

            <div className={styles.buttonsWrapper}>
              <Button
                newStyles={styles.button}
                onClickFunc={handleFeedbackClick}
              >
                <div className={styles.buttonContent}>
                  <img src={techRequest} alt="techRequest" />
                  <span>
                    Техническая поддержка
                  </span>
                </div>
                <img src={arrowIcon} alt='arrow icon' />
              </Button>
            </div>
          </div>

        </section>
      </main>
      <ModalFeedback />
    </>
  );
};
